import type { VirtualNode } from './types';
import { VirtualNodeRenderer } from './VirtualNodeRenderer';
import type { VirtualRendererOptions } from './VirtualRenderer';

export type VirtualNodeCollectionRendererProps = {
  options: VirtualRendererOptions;
  nodes: VirtualNode[];
};

export const VirtualNodeCollectionRenderer = ({
  nodes,
  options,
}: VirtualNodeCollectionRendererProps) => {
  return (
    <>
      {nodes.map((node: VirtualNode, index: number) => (
        <VirtualNodeRenderer key={index} node={node} options={options} />
      ))}
    </>
  );
};
